import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import { useLocation, Link } from 'react-router-dom';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import FileSection from './formSections/file';
import { useTranslation } from 'react-i18next';

import useDocuments from '../useDocuments';
import FormHelper from '../../../../../helpers/FormHelper';
import moment from 'moment';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    form,
    handleCreateOrUpdate,
    updateInProcess,
    shoppingCenters,
    categories,
    shops,
    singleItem,
    loading,
  } = useDocuments(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const viewPage = pathname.replace('/edit', '');
  const title = isNew ? t('PUBBLICA DOCUMENTO') : t('MODIFICA CONTENUTO');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            title: '',
            company_document_category_id: '',
            publishing_date: moment(new Date()),
            company_id: '',
            file: null,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          {!loading && (
            <>
              <InfoSection
                shops={shops}
                categories={categories}
                shoppingCenters={shoppingCenters}
              />
              <FileSection
                file={
                  singleItem?.id
                    ? {
                        url: singleItem.file,
                        name: `${singleItem.file_name} file`,
                      }
                    : null
                }
              />
            </>
          )}
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              loading={updateInProcess}
              icon={<CheckOutlined />}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
